<template>
  <div class="widget-preview-item">
    <div class="background-image" v-if="backgroundUrl" :style="{ 'background-image': backgroundUrl }">
      <div class="widget-card" v-if="!isViewMessage">
        <div class="screen-name">
          @{{ post.screenName }}
          <div class="icon" v-if="classIcon">
            <div :class="classIcon"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget-card-text" v-if="isViewMessage">
      <div class="screen-name mb-x1">
        @{{ post.screenName }}
        <div class="icon" v-if="classIcon">
          <div :class="classIcon"></div>
        </div>
      </div>
      <div class="widget-message" v-html="message"></div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    post: Object,
    isViewMessage: Boolean,
    snsType: String
  },
  computed: {
    message() {
      return this.post.message.replace(/https:\/\/twitter.com\/(\w+)\/(\w+)\/(\w+)/, '')
    },

    backgroundUrl() {
      if (this.post.mediaUrl) {
        return `url(${this.post.mediaUrl})`
      }

      if (!this.isViewMessage) {
        return `url(${require('@/client/assets/images/no-photo.png')})`
      }

      return ''
    },

    classIcon() {
      if (!this.post.type) return ''

      let icon = ''

      switch (this.post.type) {
        case 'image':
          icon = 'image'
          break
        case 'carousel':
          icon = 'image-multiple'
          break
        case 'video':
          icon = 'movie'
          break
        default:
          icon = 'format-text'
      }

      return `mdi mdi-${icon}`
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.widget-preview-item {
  border: 1px solid $border-color;
}

.background-image {
  position: relative;
  height: $spacing-unit * 30;
  background-position: 50% 50%;
  background-size: cover;
}

.screen-name {
  display: flex;
  justify-content: space-between;
  font-size: $font-small-size;
}

.widget-card {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  color: $text-color-white;
  background-color: rgb(0 0 0 / 30%);
}

.widget-card-text {
  padding: $spacing-unit;
  color: $text-color;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.widget-message {
  font-size: $font-small-size;
  line-height: $spacing-unit * 2;
}

.mdi {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: $font-large-size;
}

.icon {
  align-self: center;
}
</style>
